enum EScenario {
  SEND_EMAIL_TO_MANAGER = 'sendEmailToManager',
  CREATE_GENERATOR = 'createGenerator',
  MOCK_GENERATOR = 'createTestGenerator',
  DEFAULT = 'default',
  TEST_GENERATOR = 'testGenerator',
}

export default EScenario;
